//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Vue from 'vue'
    import {wxShareConfig} from '../js/common/utils'
    import configInfo from "../configInfo.js"
    export default {
        name: 'leagueHeader',
        props: ['leagueBasicInfo'],
        watch: {
            leagueBasicInfo: function () {
                this._reload(this.leagueBasicInfo);
            }
        },
        ready () {
            $.init();
        },
        data () {
            return {
                league_logo_url: '',
                league_time: "",
                league_status_label: "",
                league_title: "",
                league_logo: "",
                league_status: ""
            }
        },
        mounted(){
            this._reload(this.leagueBasicInfo);
        },
        computed: {},
        methods: {
            _reload(leagueBasicInfo) {
                // 增加空值容错，避免报错
                if (!leagueBasicInfo) return;
                
                this.league_title = leagueBasicInfo.title;
                this.league_status = leagueBasicInfo.league_status;
                
                if ("registering" == leagueBasicInfo.league_status) {
                    var buffer = new Array();
                    buffer.push("报名时间 ");
                    buffer.push(leagueBasicInfo.reg_start_time);
                    buffer.push(" - ");
                    buffer.push(leagueBasicInfo.reg_end_time);
                    this.league_time = buffer.join("");
                    this.league_status_label = "报名中";
                }
                if ("registered" == leagueBasicInfo.league_status) {
                    var buffer = new Array();
                    buffer.push("比赛时间 ");
                    buffer.push(leagueBasicInfo.league_start_time);
                    this.league_time = buffer.join("");
                    this.league_status_label = "待开赛";
                }
                if ("inprogress" == leagueBasicInfo.league_status) {
                    var buffer = new Array();
                    buffer.push("比赛时间 ");
                    buffer.push(leagueBasicInfo.league_start_time);
                    this.league_time = buffer.join("");
                    this.league_status_label = "比赛中";
                }
                if ("finished" == leagueBasicInfo.league_status) {
                    var buffer = new Array();
                    buffer.push("比赛时间 ");
                    buffer.push(leagueBasicInfo.league_start_time);
                    this.league_time = buffer.join("");
                    this.league_status_label = "已结束";
                }
                
                this.league_logo = leagueBasicInfo.league_logo;
                // 容错：避免logo为空时调用方法报错
                if (this.league_logo && this.hagkApi) {
                    this.league_logo_url = this.hagkApi.getImgAssetById(this.league_logo).url;
                }
            }
        },
        components: {}
    }



// WEBPACK FOOTER //
// ./src/components/LeagueHeader.vue